import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import { useIntl } from '@/intl'
import { PriceArea, PriceAreaSize } from '@sunwebgroup/ui-components/uds'
import { PriceDetails } from './PriceDetails'

export function PriceInfo({
  accommodationId,
  departureDateRaw,
  durationRaw,
  mealPlan,
  price,
  priceDiscounts,
  transportType,
  size = 'L',
  participants,
  ...rest
}: PriceInfoProps) {
  const intl = useIntl()
  const priceText = intl.formatMessage({ id: 'price_box_price_text' })
  const priceFormatted = intl.formatTruncatedCurrency(price)
  const formattedPriceDiscounts = priceDiscounts
    ? {
        discountPercentage: priceDiscounts.discountPercentage,
        originalPrice: intl.formatCurrency(priceDiscounts.originalPrice),
      }
    : undefined

  return (
    <PriceArea
      {...rest}
      price={priceFormatted}
      discounts={formattedPriceDiscounts}
      areaText={priceText}
      supportingText={priceDiscounts?.description}
      size={size}
    >
      <PriceDetails
        priceDetailsQueryParams={{
          transportType,
          accommodationId,
          duration: durationRaw,
          mealPlan,
          departureDate: departureDateRaw,
          participants,
        }}
      />
    </PriceArea>
  )
}

export interface PriceInfoProps {
  accommodationId: number
  departureDateRaw?: string
  durationRaw?: number
  mealPlan?: string
  price: number
  priceDiscounts?: {
    discountPercentage: number
    originalPrice: number
    description?: string
  }
  transportType?: string
  size?: PriceAreaSize
  participants?: RoomsParticipantDistribution
}
